'use strict';

angular.module('licensure.services')
    .factory('CertificationLevels', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/CertificationLevels', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        d.reject(response.data);
                    });

                return d.promise;
            }
        }
    }])
;